import { FormControlLabel, Grid, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { IFormFieldKeyLookupManage } from "../../../_common/models/formFieldKeyLookup";
import { PrimaryButton } from "../../../_components/button/primary.button";
import { toastr } from "../../../_components/toastr/toastr";
import { formFieldKeyLookupService } from "../../../_services/formFieldKeyLookup.service";
import { FormFieldKeyAutoComplete } from "../../../_components/autocomplete/formFieldKey.autoComplete";

export function FormFieldKeyLookupManage(params: {
    emitOnSave: () => void,
    emitOnDelete: () => void,
}) {
    const navigate = useNavigate();
    const { formFieldKeyId, formFieldKeyLookupId, formTemplateSectionId } = useParams<{ formFieldKeyId: string, formFieldKeyLookupId: string, formTemplateSectionId: string }>();
    const _formFieldKeyId = Number(formFieldKeyId);
    const _formFieldKeyLookupId = Number(formFieldKeyLookupId);

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [formFieldKeyActions, setFormFieldKeyActions] = useState([]);

    const [data, setData] = useState<IFormFieldKeyLookupManage>({
        id: 0,
        label: "",
        lookupValue: "",
        formFieldKeyId: _formFieldKeyId,
        showLabel: false,
        hasSelectCondition: false,
        selectConditionText: "",
        isCorrectAnswer: false,
        description: "",
        formFieldActionId: null,
        conditionFormFieldKeyId: 0,
        conditionFormFieldKeyValue: "",
        subValue:""
    });

    function fetchData() {
        setIsLoading(true);
        return formFieldKeyLookupService
            .get(_formFieldKeyLookupId)
            .then(
                (json: any) => {
                    setData(json)
                }
            )
            .finally(() => setIsLoading(false));
    }

    useEffect(() => {
        if (!!_formFieldKeyLookupId)
            fetchData();
    }, [_formFieldKeyLookupId]);

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return formFieldKeyLookupService
            .submit(data)
            .then(
                () => {
                    toastr.success("Created successfully");
                    params.emitOnSave();
                    navigate(-1);
                },
                (e) => {
                    console.log(e);
                    toastr.error("Please verify that the form is valid");
                }
            )
            .finally(() => setIsSaving(false));
    }

    function remove(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return formFieldKeyLookupService
            .disable(data.id)
            .then(
                () => {
                    toastr.success("Deleted successfully");
                    params.emitOnDelete();
                    navigate(-1);
                },
                (e) => {
                    console.log(e);
                    toastr.error("Please verify that the form is valid");
                }
            )
            .finally(() => setIsSaving(false));
    }

    function handleChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.value } });
    };

    function disable() {
        setIsSaving(true);

        return formFieldKeyLookupService
            .disable(data.id)
            .then(
                () => {
                    toastr.success("Closed successfully");
                    params.emitOnSave();
                    navigate(-1);
                }
            )
            .finally(() => setIsSaving(false));
    }

    function handleChangeSwitch(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: !__data[event.target.name] } });
    };

    function handleConditionChangeSwitch(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: !__data[event.target.name], label: [event.target.name] ? data.lookupValue : "" } });
    };

    return (

        <ValidatorForm onSubmit={submit} noValidate>

            <Grid container spacing={1} >


                < Grid item xs={12}>
                    <TextValidator
                        autoFocus
                        label="Option Value"
                        value={data.lookupValue}
                        name="lookupValue"
                        required
                        fullWidth
                        validators={['required']}
                        errorMessages={['This field is required']}
                        onChange={handleChange}
                        variant="filled"
                    />
                </Grid>

                < Grid item xs={12}>
                    <TextValidator
                        autoFocus
                        label="Sub Value"
                        value={data.subValue}
                        helperText="Mostly used for licence pricing"
                        name="subValue"
                        fullWidth
                        onChange={handleChange}
                        variant="filled"
                    />
                </Grid>

                < Grid item xs={12}>
                    <TextValidator
                        autoFocus
                        label="Description"
                        value={data.description}
                        name="description"
                        fullWidth
                        onChange={handleChange}
                        variant="filled"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Switch checked={data.showLabel} onChange={handleConditionChangeSwitch} name="showLabel" />}
                        label="Show Label"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Switch checked={data.hasSelectCondition} onChange={handleChangeSwitch} name="hasSelectCondition" />}
                        label="Has Select Condition"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Switch checked={data.isCorrectAnswer}
                            onChange={handleChangeSwitch}
                            name="isCorrectAnswer" />}
                        label="Is Correct Answer"
                    />
                </Grid>


                {data.showLabel === true &&
                    <Grid item xs={12}>
                        <TextValidator
                            label="Option Label"
                            value={data.label}
                            name="label"
                            required
                            fullWidth
                            validators={['required']}
                            errorMessages={['This field is required']}
                            onChange={handleChange}
                            variant="filled"
                        />
                    </Grid>
                }


                {(data.hasSelectCondition === true) &&
                    <Grid item xs={12}>
                        <TextValidator
                            label="Select Condition"
                            value={data.selectConditionText}
                            name="selectConditionText"
                            required
                            fullWidth

                            validators={['required']}
                            errorMessages={['This field is required']}
                            onChange={handleChange}
                            variant="filled"
                        />
                    </Grid>
                }


                <Grid item xs={6}>

                    <FormFieldKeyAutoComplete
                        itemId={data.conditionFormFieldKeyId}
                        name={"conditionFormFieldKeyId"}
                        parentId={Number(formTemplateSectionId)}
                        onItemChange={handleChange} />
                </Grid>

                <Grid item xs={6}>
                    <TextValidator
                        label="Value"
                        value={data.conditionFormFieldKeyValue}
                        name="conditionFormFieldKeyValue"
                        required={!!data.conditionFormFieldKeyId}
                        fullWidth
                        validators={!!data.conditionFormFieldKeyId ? ['required'] : []}
                        errorMessages={!!data.conditionFormFieldKeyId ? ['This field is required'] : []}
                        onChange={handleChange}
                        variant="filled"
                    />

                </Grid>
                <Grid item xs={(_formFieldKeyId > 0) ? 6 : 12}>
                    <PrimaryButton isLoading={isLoading} isSaving={isSaving} type="submit" variant="save">Save</PrimaryButton>
                </Grid>

                {(_formFieldKeyId > 0) &&
                    <Grid item xs={6}>
                        <PrimaryButton isSaving={isSaving} isLoading={isLoading} onClick={disable} type="button" variant="remove">Delete</PrimaryButton>
                    </Grid>
                }

            </Grid>
        </ValidatorForm >
    );
}